import React, {useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css"; 
import backgroundImage from "../../../assets/images/contact_img.png";

const SupportHero: React.FC = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Duration of the animation
      easing: 'ease-in-out', // Easing function
      once: true, // Animation should run once
    });
  }, []);

  return (
    <section
      className="w-11/12 mx-auto h-[600px] mt-12 flex flex-col items-center justify-center text-center text-white relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="bg-purple-900 bg-opacity-60 w-full h-full absolute top-0 left-0"></div>
      <div data-aos="fade-up" data-aos-delay="100" className="relative z-10">
        <h1 data-aos="fade-up" data-aos-delay="200" className="text-4xl sm:text-7xl font-bold mb-4">Reach out to us</h1>
        <p data-aos="fade-up" data-aos-delay="300" className="text-md sm:text-2xl max-w-2xl mx-auto">
          Do you have any questions or ideas about Beat Fussion? Don’t hesitate to reach out to us today.
        </p>
      </div>
    </section>
  );
};

export default SupportHero;
